<template>
  <div class="service-overview full wow fadeInUp" data-wow-duration="2s" data-wow-delay=".5s">
    <span v-if="$root.isAdmin()" class="hidden" v-bind="$parent.dKey('b3array#' + index + '#image')">{{image}}</span>
    <img v-bind:src="image" alt="">
    <div v-bind:class="{'show-more': $root.isAdmin()}" class="service-overview-content">
      <h5 v-bind="$parent.dKey('b3array#' + index + '#title')">{{title}}</h5>
      <div v-bind="$parent.dKey('b3array#' + index + '#content')" v-html="content"></div>
      <router-link :event="$root.isAdmin() ? '' : 'click'" v-bind="$parent.dKey('b3array#' + index + '#linkText')" v-bind:to="'/' + $root.locale + '/' + href" class="details-btn">{{linkText}}</router-link>
      <span v-if="$root.isAdmin()" class="hidden" v-bind="$parent.dKey('b3array#' + index + '#link')">{{href}}</span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ServiceArticle',

  props: ['index', 'title', 'content', 'href', 'image', 'linkText'],

  mounted() {
    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })

    if (!this.$root.isAdmin()) {
      $('.service-overview').hover(function() {
        $(this).find('.service-overview-content').addClass('show-more');
      }, function() {
        $(this).find('.service-overview-content').removeClass('show-more');
      })
    }
  }
}

</script>